import React, { useState, useEffect } from "react";
import "./Style.css";
import {
  Link,
  useNavigate,
  useLocation,
  BrowserRouter,
} from "react-router-dom";
import Header from "../Components/header";
import { GraphQLClient } from "graphql-request";
import { RichText } from "@graphcms/rich-text-react-renderer";
import Footer from "../Components/footer";
import SliderComponent from "../Components/carouse";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Helmet } from "react-helmet";
import AccessWarningBanner from "../Components/banner";
import GoogleOneTap from "../Components/GoogleOneTap";

const getLastIssue = async () => {
  const client = new GraphQLClient(
    "https://api-eu-central-1-shared-euc1-02.hygraph.com/v2/clweq2m6a000001w67aqzeh7x/master"
  );

  const query = `query MyQuery {
    rivistes(first: 1, orderBy: dataPubblicazione_DESC) {
      id
      numeroRivista
      prezzo
      slugRivista
      copertina {
        fileName
        id
        url
      }
      sommario {
        raw
      }
    }
  }`;

  try {
    const data = await client.request(query);
    return data.rivistes;
  } catch (error) {
    console.error("Error fetching issues:", error);
    throw error;
  }
};

const Index = () => {
  const [isSliderLoading, setIsSliderLoading] = useState(true); // Aggiungi lo stato
  const [ultimaRivista, setUltimaRivista] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    const fetchLastIssues = async () => {
      try {
        const lastIssue = await getLastIssue();
        console.log(lastIssue);
        setUltimaRivista(lastIssue[0]);
        console.log(lastIssue[0].sommario.raw);
        //setTimeout(() => {
        setIsLoading(false);
        //  }, 2000);
      } catch (error) {
        console.error("Error fetching page:", error);
      }
    };
    fetchLastIssues();
  }, []);

  useEffect(() => {
    console.log(isSliderLoading);
  }, [isSliderLoading]);
  if (error) {
    return <div>ERROR 404</div>;
  }
  return (
    <div>
      <Helmet>
        <title>
          Modellistica International - Rivista di Aeromodelli e Modellismo
        </title>
        <meta
          name="description"
          content="Scopri il mondo dell'aeromodellismo e modellismo con Modellistica International, la rivista dedicata agli appassionati."
        />
        <meta
          name="keywords"
          content="modellistica, aeromodelli, modellistica international, modellismo"
        />
        <link
          rel="canonical"
          href={`https://www.modellisticaint.it.com${location.pathname}`}
        />
      </Helmet>
      {
        //<AccessWarningBanner />
      }
      <Header />

      {
        //TODO sistema per banner
        /* <div className="w-full bg-yellow-300 text-center py-3 px-2 text-black font-semibold text-lg shadow-md z-50">
        Siamo in ferie fino all'11 agosto 2025: tutte le spedizioni verranno
        effettuate dopo questa data.
      </div> */
      }
      <GoogleOneTap />
      <div className="relative w-screen h-[500px] min-h-[500px] md:p-12 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <SliderComponent
            setIsSliderLoading={setIsSliderLoading}
            isSliderLoading={isSliderLoading}
          />
          <div className="absolute inset-0 bg-black opacity-30"></div>
        </div>

        {!isSliderLoading && (
          <div className="relative z-10 flex flex-col items-center justify-center h-full bg-bluse-500">
            <h1 className="text-4xl font-bold text-white drop-shadow-xl">
              La rivista italiana di Aeromodellismo dinamico
            </h1>
            <div className="mt-20 flex items-center justify-center">
              <Link
                to="/abbonamenti"
                className="w-full p-6 my-5 text-xl font-bold border-4 flex justify-center items-center text-white border-red-500 bg-red-500 hover:bg-red-700 hover:border-red-700 h-12 transition"
              >
                Abbonati ora!
              </Link>
            </div>
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 justify-center sm:mt-10">
        {isLoading ? (
          <p>Caricamento in corso...</p>
        ) : ultimaRivista && ultimaRivista.copertina ? (
          <div className="flex flex-col md:grid md:grid-cols-2 gap-8 p-12 w-full bg-grseen-500">
            <div className="flex justify-center md:justify-self-end md:items-center lg:mr-20 lg:w-5/6  bg-sred-500 lg:mt-10  ">
              <img
                src={ultimaRivista.copertina.url}
                alt={ultimaRivista.copertina.fileName}
                style={{
                  width: "100%", // Assicura che l'immagine si espanda nel contenitore
                  maxWidth: "1400px", // Imposta una dimensione massima più grande
                  alignSelf: "flex-start",
                }}
              />
            </div>

            <div className="md:text-left md:w-3/4">
              <p className="text-3xl font-bold mb-4 text-gray-700">
                {ultimaRivista.numeroRivista}
              </p>
              <div className="text-xl text-left text-gray-500 mt-2">
                <RichText
                  content={ultimaRivista.sommario.raw}
                  renderers={{
                    li: ({ children }) => <li className="mb-6">{children}</li>,
                  }}
                />
              </div>
              <Link
                to={`/arretrati/${ultimaRivista.slugRivista}`}
                className="w-full my-5 font-bold border-4 mb-40 flex justify-center items-center text-red-500 border-red-500 hover:text-white hover:bg-red-500 h-12 transition"
              >
                COMPRA ADESSO L'ULTIMO NUMERO
              </Link>
            </div>
          </div>
        ) : (
          <p>Rivista non disponibile</p>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Index;
